import React from 'react';

interface SegmentedControlProps {
  options: Array<{ value: string; label: string; icon?: string }>;
  value: string;
  onChange: (value: string) => void;
  title?: string;
}

export const SegmentedControl: React.FC<SegmentedControlProps> = ({
  options,
  value,
  onChange,
  title,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
      }}
    >
      {title && (
        <span
          style={{
            fontSize: '14px',
            fontWeight: 400,
            color: '#1a1a1a',
            fontFamily: 'Inter, sans-serif',
          }}
        >
          {title}
        </span>
      )}
      <div
        style={{
          display: 'flex',
          gap: '4px',
          backgroundColor: '#EEF1F4',
          borderRadius: '8px',
          padding: '2px',
        }}
      >
        {options.map((option) => {
          const isActive = value === option.value;
          return (
            <button
              key={option.value}
              onClick={() => onChange(option.value)}
              style={{
                padding: '6px 12px',
                borderRadius: '6px',
                border: 'none',
                backgroundColor: isActive ? '#fff' : 'transparent',
                color: isActive ? '#1a1a1a' : '#666',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: isActive ? 500 : 400,
                fontFamily: 'Inter, sans-serif',
                transition: 'all 0.2s ease',
                boxShadow: isActive ? '0 1px 3px rgba(0, 0, 0, 0.1)' : 'none',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
              }}
            >
              {option.icon && <span>{option.icon}</span>}
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
